import * as React from 'react';

import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import AppState from '@webapp/store/state';

import styled, { css } from 'styled-components';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import Button, { ButtonType } from '@components/actions/button';

import NoDecoration from './no-decoration';
import DashboardItemImg, { DashboardImage } from './item-img';
import { AnimatePresence } from 'framer-motion';

export interface NewDashboardItemProps {
  className?: string;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  btnTxt?: React.ReactNode;
  btnDisabled?: boolean;
  btnType?: ButtonType;
  images?: DashboardImage[];
  noBottomLine?: boolean;
  to?: string;
  imgComponent?: React.ReactNode;
  onClick?: (to?: string) => void;
  clientId: string;
  subscriptionId: string;
}
interface StateProps {
  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const NewDashboardItem: React.FC<NewDashboardItemProps & StateProps> = (
  props
) => {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick(props.to);
    }
  };

  return (
    <MotionOpacity>
      <div className={props.className}>
        <Content>
          <Title customFont="bold" type="big-title">
            {props.title}
          </Title>
          <Subtitle>{props.subtitle}</Subtitle>
          {props.btnTxt ? (
            props.to ? (
              <>
                <ButtonWrapper
                  fullWidth
                  buttonType={props.btnType}
                  disabled={props.btnDisabled}
                  onClick={handleClick}
                >
                  {props.btnTxt}
                </ButtonWrapper>
              </>
            ) : (
              <ButtonWrapper
                fullWidth
                buttonType={props.btnType}
                disabled={props.btnDisabled}
                onClick={handleClick}
              >
                {props.btnTxt}
              </ButtonWrapper>
            )
          ) : props.onClick ? (
            <ButtonWrapper
              fullWidth
              buttonType={props.btnType}
              disabled={props.btnDisabled}
              onClick={handleClick}
            >
              {props.btnTxt}
            </ButtonWrapper>
          ) : null}
        </Content>
        <AnimatePresence exitBeforeEnter>
          {props.imgComponent && props.images && props.images.length > 0 ? (
            <MotionOpacity className="decoration">
              {props.imgComponent}
            </MotionOpacity>
          ) : props.images && props.images.length > 0 ? (
            <MotionOpacity className="decoration">
              <DashboardItemImg images={props.images} />
            </MotionOpacity>
          ) : (
            <NoDecoration
              className="decoration"
              text={<Translate id="DASHBOARD.NEW_DASHBOARD.NO_DRAFTS" />}
            />
          )}
        </AnimatePresence>
      </div>
    </MotionOpacity>
  );
};

export default connect(mapStateToProps)(styled(NewDashboardItem)`
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(10, 1fr);
  padding-bottom: 40px;
  width: 100%;

  .decoration {
    grid-column: 8 / 11;
    margin-left: auto;
  }

  ${(props) =>
    !props.noBottomLine &&
    css`
      &:after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 1px;
        opacity: 0.5;
        background-color: ${({ theme }) => theme.colors.border};
        border-radius: 4px;
      }
    `}
`);

const Content = styled.div`
  grid-column: span 6;
  width: 100%;
  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    grid-column: span 5;
  }
`;

const Title = styled(Typography)`
  margin-bottom: 8px;
  grid-row: 1;
`;

const Subtitle = styled(Typography)`
  margin-bottom: 32px;
  line-height: 17px;
  grid-row: 2;
  color: ${({ theme }) => theme.colors.tertiary};
`;

const ButtonWrapper = styled(Button)`
  grid-row: 3;
  width: 100% !important;
`;
